module.exports = __webpack_public_path__ + "img/color3.a7f41231.png";